import React from 'react';
import { useLocation, NavLink } from 'react-router-dom';
const BottomNavigation = () => {
    const location = useLocation();
    const path = location.pathname;
    const tabs = [
        {
            path: '/',
            label: 'Home',
            icon: (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-6 w-6", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" })))
        },
        {
            path: '/resources',
            label: 'Resources',
            icon: (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-6 w-6", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" })))
        },
        {
            path: '/search',
            label: 'Search',
            icon: (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-6 w-6", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" })))
        },
        {
            path: '/agent',
            label: 'Agent',
            icon: (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-message-circle-more-icon lucide-message-circle-more" },
                React.createElement("path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z" }),
                React.createElement("path", { d: "M8 12h.01" }),
                React.createElement("path", { d: "M12 12h.01" }),
                React.createElement("path", { d: "M16 12h.01" })))
        },
        {
            path: '/floorplan',
            label: 'Floor Plan',
            icon: (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-6 w-6", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" })))
        }
    ];
    return (React.createElement("div", { className: "fixed bottom-0 left-0 right-0 bg-white border-t flex justify-around items-center py-1 shadow-[0_-2px_10px_rgba(0,0,0,0.05)] z-10" }, tabs.map((tab) => (React.createElement(NavLink, { key: tab.path, to: tab.path, className: ({ isActive }) => `flex flex-col items-center justify-center px-3 py-2 rounded-md transition-all duration-300 ${isActive
            ? 'text-blue-600 bg-blue-50 scale-110'
            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'}` },
        React.createElement("div", { className: "flex flex-col items-center" },
            tab.icon,
            React.createElement("span", { className: "text-xs mt-1 font-medium" }, tab.label)))))));
};
export default BottomNavigation;
